module.exports = __webpack_public_path__ + "static/media/img-destaque-internas.095a8760.jpg";